import { Link } from "react-router-dom";

const MENTION_RE = /(^|[^A-Za-z0-9_])@([a-zA-Z0-9_]{2,30})/g;

/**
 * Render plain text with @username turned into Link components.
 * Returns an array of React nodes.
 */
export const renderWithMentions = (text) => {
  if (!text) return null;
  const out = [];
  let lastIdx = 0;
  let m;
  let key = 0;
  MENTION_RE.lastIndex = 0;
  while ((m = MENTION_RE.exec(text)) !== null) {
    const [full, lead, name] = m;
    const start = m.index + lead.length;
    if (start > lastIdx) out.push(text.slice(lastIdx, start));
    out.push(
      <Link
        key={`mention-${key++}-${name}`}
        to={`/profile/${name}`}
        data-testid={`mention-link-${name}`}
        style={{ color: "var(--brand-accent)", fontWeight: 500, textDecoration: "none" }}
      >
        @{name}
      </Link>
    );
    lastIdx = start + 1 + name.length; // skip '@' + name
  }
  if (lastIdx < text.length) out.push(text.slice(lastIdx));
  return out;
};
